import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for list menu
export const MenuList = createSlice({
  name: "MenuList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_MenuList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_MenuList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_MenuList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    MenuList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearMenuList: (state) => {
      state.data = [];
    },
  },
});
export default MenuList.reducer;
export const {
  list_MenuList,
  success_api_call_MenuList,
  failure_api_call_MenuList,
  MenuList_is_first,
  clearMenuList,
} = MenuList.actions;
